import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import TopicsSection from './components/TopicsSection';
import CommentsSection from './components/CommentsSection';
import FaqSection from './components/FaqSection';
import RankingSection from './components/RankingSection';
import FeaturesSection from './components/FeaturesSection';
import UpdatesSection from './components/UpdatesSection';
import IndexSection from './components/IndexSection';
import CardsSection from './components/CardsSection';
import MediaSection from './components/MediaSection';
import CarouselSection from './components/CarouselSection';
import ContactSection from './components/ContactSection';
import AppSection from './components/AppSection';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <HeroSection />
        <AboutSection />
        <TopicsSection />
        <CommentsSection />
        <FaqSection />
        <RankingSection />
        <FeaturesSection />
        <UpdatesSection />
        <IndexSection />
        <CardsSection />
        <MediaSection />
        <CarouselSection />
        <ContactSection />
        <AppSection />
      </main>
      <Footer />
    </>
  );
}